<template>
  <div ref="containerRef" class="best-sellers py-16 !m-0">
    <div class="best-sellers-inner">
      <div class="title" v-if="toplineText || headlineText">
        <span class="sub-heading text-base 3xl:text-md font-marcellus text-purple" v-if="toplineText">{{ toplineText }}</span>
        <h2 id="best-sellers-title" class="heading text-2xl lg:text-6xl 3xl:text-10xl font-marcellus text-grey-700 leading-[30px] md:leading-none" v-if="headlineText">
          {{ headlineText }}
        </h2>
      </div>
      <div class="content mt-7 lg:mt-10">
        <ul
          class="flex flex-nowrap items-start md:flex-wrap hide-scrollbar -mx-5 px-5 md:px-0 md:mx-0 md:grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-4 md:gap-x-6 gap-y-14 overflow-x-scroll md:overflow-x-hidden snap-x-disable snap-mandatory">
          <!-- Product Card -->
          
          <template
            v-for="(box, index) in Boxes"
          >
            <li 
              v-if="index < 5 && box.boxProduct?.product"
              :key="index"
              class="snap-center-disable">
              <ProductCard
                  v-if="index != 5"
                  :key="box.boxProduct?.product?.id"
                  class="h-full"
                  :product="box.boxProduct?.product"
                  :variants="false"
                />
                
            </li>
          </template>

          <!-- Desktop Showroom Banner -->
          <li class="snap-center-disable hidden md:block">
            <div class="showroom-banner group/showroom-banner">
              <div
                class="relative overflow-hidden rounded-[15px] md:rounded-[20px] bg-light-grey aspect-square md:aspect-[8/9] flex items-center justify-center">
                <SharedImage
                  loading="lazy"
                  v-if="showRoomImage"
                  :src="showRoomImage.media?.url"
                  :alt="showRoomImage.media?.alt ? showRoomImage.media?.alt : $t('mysofbed')"
                  imgClass="w-full h-full object-cover group-hover/showroom-banner:scale-105 transition-all duration-300"
                  :height="showRoomImage.media?.metaData?.height"
                  :width="showRoomImage.media?.metaData?.width"
                  format="webp" 
                  class="w-full h-full object-cover"
                  :sizes="{ desktop: '387x435', tablet: '291x327', mobile: '328x369' }"
                  :mimeType="showRoomImage?.media?.mimeType"
                />
                <div
                  class="absolute font-marcellus inset-0 bg-black bg-opacity-50 flex flex-col justify-center items-center text-white p-4">
                  <h3 v-if="showRoomText1" v-html="showRoomText1" class="text-lg 2xl:text-xl 3xl:text-4xl text-center leading-[1.2] font-normal -mt-4">
                  </h3>
                  <span class="text-center text-4xl my-2 3xl:my-4" aria-hidden="true">&amp;</span>
                  <h3 v-if="showRoomText2" v-html="showRoomText2" class="text-lg 2xl:text-xl 3xl:text-4xl text-center leading-[1.2]">
                  </h3>
                <SharedButton
                  :button="link"
                  :isInnerHtml="true"
                  class="mt-8 text-md flex items-center absolute bottom-8 2xl:bottom-12 group/link">
                    <span class="font-mulish hover:underline" v-if="link?.title">{{ link?.title }}</span>
                    <i
                      class="icon-arrow-right text-sm ml-2 group-hover/link:translate-x-2 transition-transform duration-300 font-bold relative top-[1px]"
                      aria-hidden="true"></i>
                  </SharedButton>
                </div>
              </div>
              <div class="showroom-info mt-2 text-center">
                <h3 class="text-lg 2xl:text-4xl 3xl:text-5xl font-normal">Showrooms</h3>
              </div>
            </div>
          </li>

          <template
            v-for="(box, index) in Boxes"
          >
            <li 
              v-if="index >= 5 && box.boxProduct?.product"
              :key="index"
              class="snap-center-disable">
              <ProductCard
                  :key="box.boxProduct?.product?.id"
                  class="h-full"
                  :product="box.boxProduct?.product"
                  :variants="false"
                />
                
            </li>
          </template>

        </ul>

        <div class="progress-bar block md:hidden mt-8 h-[6px] bg-gray-300 rounded-full mx-10">
          <div class="progress-bar-inner h-[6px] bg-primary transition-all ease-linear rounded-full w-[0%]"></div>
        </div>

        <!-- Mobile Showroom Banner -->
        <div class="showroom-banner block md:hidden mt-16 md:mt-0 group/showroom-banner relative">
          <div class="showroom-info block md:hidden mb-4 text-left" v-if="showRoomTitle">
            <h3 class="text-2xl 2xl:text-4xl 3xl:text-5xl font-normal">{{ showRoomTitle }}</h3>
          </div>
          <div
            class="relative overflow-hidden rounded-[15px] md:rounded-[20px] bg-light-grey aspect-square md:aspect-[8/9] flex items-center justify-center">
            <SharedImage
              loading="lazy"
              v-if="showRoomImage"
              :src="showRoomImage.media?.url"
              :alt="showRoomImage.media?.alt ? showRoomImage.media?.alt : $t('mysofbed')"
              imgClass="w-full h-full object-cover group-hover/showroom-banner:scale-105 transition-all duration-300"
              :height="showRoomImage.media?.metaData?.height"
              :width="showRoomImage.media?.metaData?.width" 
              format="webp"
              class="w-full h-full object-cover"
              :sizes="{ desktop: '387x435', tablet: '291x327', mobile: '328x369' }"
              :mimeType="showRoomImage?.media?.mimeType"
            />
            <div
              class="absolute font-marcellus inset-0 bg-black bg-opacity-50 flex flex-col justify-center items-center text-white p-4">
              <h3 v-if="showRoomText1" v-html="showRoomText1" class="text-xl 2xl:text-xl 3xl:text-4xl text-center leading-[1.2] font-normal -mt-4">
              </h3>
              <span class="text-center text-4xl my-2 3xl:my-4" aria-hidden="true">&amp;</span>
              <h3 v-if="showRoomText2" v-html="showRoomText2" class="text-xl 2xl:text-xl 3xl:text-4xl text-center leading-[1.2]">
              </h3>

              <SharedButton
              :button="link"
              :isInnerHtml="true"
              class="mt-8 text-md flex items-center absolute bottom-8 2xl:bottom-12 group/link" >
                <span class="font-mulish hover:underline" v-if="link?.title">{{ link?.title }}</span>
                <i
                  class="icon-arrow-right text-sm ml-2 group-hover/link:translate-x-2 transition-transform duration-300 font-bold relative top-[1px]"
                  aria-hidden="true"></i>
              </SharedButton>
            </div>
          </div>
          <div class="showroom-info hidden md:block mt-2 text-center" v-if="showRoomTitle">
            <h3 class="text-lg 2xl:text-4xl 3xl:text-5xl font-normal">{{ showRoomTitle }}</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { CmsElementProductGrid } from "~/composables/useCustom";
import { useProgressBar } from '@/composables/useProgressBar';
import { ref } from "vue";
import SharedImage from "~/components/shared/SharedImage.vue";

const props = defineProps<{
  content: CmsElementProductGrid;
}>();

const { toplineText, headlineText, showRoomTitle, showRoomText1, showRoomText2, link, showRoomImage, Boxes } = props.content.data;

const containerRef = ref<HTMLElement | null>(null);

useProgressBar(containerRef); 

</script>